"use strict";
exports.__esModule = true;
exports.PaymentCategory = exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["SCHEDULED"] = "SCHEDULED";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["AUTHORIZED"] = "AUTHORIZED";
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["FUNDED"] = "FUNDED";
    PaymentStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentCategory;
(function (PaymentCategory) {
    PaymentCategory["FIRST_PAYMENT"] = "1ST_PAYMENT";
    PaymentCategory["SECOND_PAYMENT"] = "2ND_PAYMENT";
    PaymentCategory["MEMBERSHIP_FEE"] = "MEMBERSHIP_FEE";
    PaymentCategory["ADDITIONAL_DEPOSIT"] = "ADDITIONAL_DEPOSIT";
})(PaymentCategory = exports.PaymentCategory || (exports.PaymentCategory = {}));
